import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard, 
  CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import StockInputs from '../../components/StockInputs/StockInputs';
import { updateStockRequest } from '../../store/stock/stockActions';

const UpdateStock = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.stockReducer.isLoading);
  const submitResponse = useSelector(state => state.stockReducer.updateStockData);
  const initialData = location.state?.stock || null;

  const handleSubmit = (data) => {
    dispatch(updateStockRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/stock');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/stock" onClick={e => 
          { e.preventDefault(); handleCancel(); }}>{t('stock')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateStock')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('updateStock')}</h4></CCardHeader>
            <CCardBody>
              <StockInputs onSubmit={handleSubmit} 
              onCancel={handleCancel} isLoading={isLoading} 
              submitResponse={submitResponse} initialData={initialData} isEdit />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default UpdateStock; 